import { adminRouter } from '@/features/admin/router/admin.router'
import { authRouter } from '@/features/auth/router/auth.router'
import { conversionCardsPublicRouter } from '@/features/conversion-cards/router/conversionCards.router'
import { launchAdminRouter } from '@/features/launch'
import { pipelineRunRouter } from '@/features/menu/router/pipeline-run.router'
import {
  snapshotDiffRouter,
  snapshotHistoryRouter,
} from '@/features/menu/router/snapshot-history.router'
import { oauthRouter } from '@/features/oauth/router/oauth.router'
import {
  adminOnboardingRouter,
  onboardingRouter,
} from '@/features/onboarding/router/onboarding.router'
import { salesAdminRouter } from '@/features/sales/router/salesAdmin.router'

import { brandRoutes } from './brandRoutes'

export default [
  {
    children: [
      ...brandRoutes,
      ...pipelineRunRouter,
      ...snapshotDiffRouter,
      ...snapshotHistoryRouter,
      ...adminRouter,
      ...salesAdminRouter,
      ...launchAdminRouter,
      ...oauthRouter,
      ...authRouter,
      ...conversionCardsPublicRouter,
      ...onboardingRouter,
      ...adminOnboardingRouter,
    ],
    component: {
      name: 'AppRouterView',
      template: '<router-view></router-view>',
    },
    path: '/',
  },
  {
    name: 'not-found',
    path: '/:catchAll(.*)',
    redirect: '/',
  },
]
